import React from 'react';
import { Box, H6, Optional } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';

import DealerProductLinesSelector from '../DealerProductLinesSelector';
import ProductLinesRadioGroup from '../DealerProductLinesSelector/ProductLinesRadioGroup';
import getProductLinesBySiteName from '../../utils/getProductLinesBySiteName';
import themeStyles from '../DealerLocatorInput/DealerLocator.style';
import useAppName from '../../hooks/useAppName';
import { SHOW_RADIO_BUTTON } from '../../utils/constants';
import useJSSComponentContext from '../../hooks/useJSSComponentContext';

const Title = themeStyles.apply(H6, 'StyledHeader');

// switch between radio button and checkbox selector
const ProductLinesSelector = SHOW_RADIO_BUTTON ? ProductLinesRadioGroup : DealerProductLinesSelector;

const DealerLocatorInputOptions = () => {
  const { t } = useTranslation();
  const siteName = useAppName();
  const productLines = getProductLinesBySiteName(siteName);

  const { SubAppTitleComponent, componentName, fields } = useJSSComponentContext();

  if (componentName && SubAppTitleComponent) return <SubAppTitleComponent fields={fields} />;

  return (
    <Box mt="35px" data-testid="cy-configured-vehicle-box">
      <Title data-testid="cy-dealer-header">{t('Sub-apps.Dealers.dealerLocatorHeading')}</Title>
      <Optional when={productLines.length > 1}>
        <ProductLinesSelector productLines={productLines} />
      </Optional>
    </Box>
  );
};

export default DealerLocatorInputOptions;
